import React from 'react';
import { MailIcon } from 'lucide-react';
export function ContactSection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3194">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3195">
        <div className="mb-12" data-id="element-3196">
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3197">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-3198">
              <MailIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-3199" />
            </div>
            <h2 className="text-2xl font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3200">
              Questions?
            </h2>
            <p className="text-base text-gray-600 mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3201">
              For questions or more information about the Self Defense Class,
              please reach out:
            </p>
            <a href="mailto:blender8044@gmail.com" className="inline-flex items-center gap-2 text-lg font-semibold transition-colors hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3202">
              blender8044@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>;
}